import { Link, useRouteMatch } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { maskDecimal } from '@givebutter/util';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { useCurrentPossibleAuction } from 'customHooks/useCurrentAuction';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { dateFromServer } from 'helpers/dates';
import { DateTime } from 'luxon';

const AuctionEndedNotification = () => {
    const match = useRouteMatch();
    const currencySymbol = useCurrencySymbol();
    const { data: campaign } = useCurrentCampaign();
    const { data: auction } = useCurrentPossibleAuction();

    return auction && dateFromServer(auction.end_at) < DateTime.now() ? (
        <AlertNotification.Root type="success">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>
                    Congratulations on completing your auction!
                </AlertNotification.Title>
                <AlertNotification.Description className="flex flex-col gap-3">
                    {auction.raised > 0 ? (
                        <>
                            You just raised {currencySymbol}
                            {maskDecimal(auction.raised)} through your auction and your campaign
                            raised {currencySymbol}
                            {maskDecimal(campaign.raised)} total. Any unsold items can be extended.
                        </>
                    ) : (
                        <>
                            Your campaign raised {currencySymbol}
                            {maskDecimal(campaign.raised)}. Any unsold items can be extended.
                        </>
                    )}
                    <Link
                        className="text-green-700 hover:text-green-800"
                        to={`${match.url}/auction/items`}
                    >
                        View items <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </AlertNotification.Description>
            </AlertNotification.Content>
            <AlertNotification.Close />
        </AlertNotification.Root>
    ) : null;
};

export { AuctionEndedNotification };
